import http from './http-common'

export type UsersResponse = {
  "id_User": number,
  "name_User": string,
  "email_User": string,
  "phone_User": string,
  "occupation_User": string,
  "planName": string,
  "amountQueries_PlansPG": number,
  "amountQueriesAvailable": number,
  "amountQueriesUsed_User": number
  "totalUsers": number,
}
export const getAllUser = (offset: number, limit: number, filter: string) => 
  http.get(`/admin/users/${offset}/${limit}`, { params: { value: filter } })

export const deleteUser = (userId: number) => http.delete(`/admin/user/${userId}`)

// POST /admin/users — convidar/criar usuário. `plan` é o ID do plano (number).
export type InviteUserRequest = {
  name: string
  email: string
  phone?: string
  plan?: number
  role: 'USER' | 'ADMIN'
  active: boolean
}

export const inviteUser = (payload: InviteUserRequest) => http.post('/admin/users', payload)
export const updateUserPlanEndDate = (userId: number, endDate: string) => {
  return http.patch(`/admin/user/${userId}/plan-end-date`, {
    endDate,
  });
};

export const getAllTransactions = (offset: number, limit: number, filter: string) => 
  http.get(`/user/transactions/${offset}/${limit}`, { params: { value: filter } })